const findNested = (values, name) => {
  const names = name.split(".");
  let v = { ...values };
  while (names.length) {
    const n = names.shift();
    // console.log(n)
    v = typeof v[n] !== "undefined" && v !== null ? v[n] : null;
  }
  return v;
};
export default findNested;
